/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { createFragmentContainer, QueryRenderer, graphql } from 'react-relay';

import { Redirect } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { Button } from './ui/button';

import QueryError from './QueryError';
import Card from './Card';
import Channel from './Channel';
import Invitations from './Invitations';
import Users from './Users';
import SimpleCurl from './SimpleCurl';
import Messages from './Messages';
import Loading from './Loading';
import RelayEnv from '../RelayEnv';
import DeleteChannelMutation from '../mutations/DeleteChannelMutation';
import DeleteChannelUserMutation from '../mutations/DeleteChannelUserMutation';

class ChannelGrid extends React.Component {
  constructor(props) {
    super(props);
    this.deleteChannel = this.deleteChannel.bind(this);
    this.leave = this.leave.bind(this);
    this.onDisableNotifs = this.onDisableNotifs.bind(this);
    this.state = {
      foo: 'bar',
      activeTab: 0,
      channelId: null,
    };
  }

  deleteChannel(e) {
    if (window.confirm('Are you sure?')) {
      return DeleteChannelMutation.commit(
        this.props.channel.owned.id,
        this.props.viewer.id,
        () => {
          return this.setState({
            redirect: true,
          });
        },
      );
    }
  }

  leave() {
    return DeleteChannelUserMutation.commit(
      this.props.viewer.id,
      this.props.viewer.id,
      this.props.channel.id,
      () => {
        if (this.props.channel.owned == null) {
          return this.setState({
            redirect: true,
          });
        }
      },
    );
  }

  onDisableNotifs() {}

  render() {
    if (this.props.channel == null || this.state.redirect) {
      return <Redirect to="/" />;
    }

    return (
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Tabs
            value={this.state.activeTab.toString()}
            onValueChange={value =>
              this.setState({ activeTab: parseInt(value) })
            }
          >
            <TabsList className="bg-white">
              <TabsTrigger value="0">Messages</TabsTrigger>
              <TabsTrigger value="1">Channel</TabsTrigger>
            </TabsList>
            <TabsContent value="0" className="mt-4">
              {this.props.channel.owned != null &&
              this.props.channel.joined != null ? (
                <div className="col-span-12 mb-4">
                  <Card>
                    <SimpleCurl
                      accessToken={this.props.viewer.accessToken.secret}
                      id={this.props.channel.id}
                    />
                  </Card>
                </div>
              ) : null}
              <div className="col-span-12">
                <Messages
                  viewer={this.props.viewer}
                  channel={this.props.channel}
                />
              </div>
            </TabsContent>
            <TabsContent value="1" className="mt-4">
              <div className="grid grid-cols-12 gap-4">
                {this.props.channel.owned != null ? (
                  <div className="col-span-12 md:col-span-6">
                    <Channel
                      viewer={this.props.viewer}
                      channelId={this.props.channel.id}
                      channel={this.props.channel.owned}
                    />
                  </div>
                ) : null}
                <div className="col-span-12 md:col-span-6">
                  <Card className="p-4">
                    {this.props.channel.joined != null ? (
                      <div className="mb-4">
                        <p className="text-sm mb-2">
                          Leave Channel to no longer receive messages
                        </p>
                        <Button onClick={this.leave}>Leave</Button>
                      </div>
                    ) : null}
                    {this.props.channel.owned != null ? (
                      <div>
                        <p className="text-sm mb-2">Delete Channel</p>
                        <Button
                          onClick={this.deleteChannel}
                          variant="destructive"
                        >
                          Delete Channel
                        </Button>
                      </div>
                    ) : null}
                  </Card>
                </div>
                {this.props.channel.owned != null ? (
                  <>
                    <div className="col-span-12 md:col-span-6">
                      <Invitations channel={this.props.channel.owned} />
                    </div>
                    <div className="col-span-12 md:col-span-6">
                      <Card className="p-4">
                        <h2 className="text-2xl font-semibold mb-4">Users</h2>
                        <Users
                          channel={this.props.channel.owned}
                          viewer={this.props.viewer}
                        />
                      </Card>
                    </div>
                  </>
                ) : null}
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    );
  }
}

ChannelGrid = createFragmentContainer(ChannelGrid, {
  channel: graphql`
    fragment ChannelView_channel on Channel {
      id
      name
      ...Messages_channel
      owned {
        id
        name
        ...Channel_channel
        ...Invitations_channel
        ...Users_channel
      }
      joined {
        id
        name
        channelId
      }
    }
  `,
});

class ChannelView extends React.Component {
  render() {
    return (
      <QueryRenderer
        query={graphql`
          query ChannelViewQuery($channel_id: ID!) {
            viewer {
              id
              accessToken {
                secret
              }
            }
            node(id: $channel_id) {
              ... on Channel {
                id
                ...ChannelView_channel
              }
            }
          }
        `}
        environment={RelayEnv}
        variables={{ channel_id: this.props.match.params.channel_id }}
        render={({ error, retry, props }) => {
          if (error) {
            return <QueryError retry={retry} error={error} />;
          } else if (props) {
            return (
              <ChannelGrid
                viewer={props.viewer}
                channel={props.node}
                {...props}
              />
            );
          } else {
            return <Loading />;
          }
        }}
      />
    );
  }
}

export default ChannelView;
